<template>
  <div
    :class="[
      _.button,
      small && _.small,
      link && _.link,
      gray && _.gray,
      inline && _.inline,
      disabled && _.disabled,
    ]"
    @click="handleClick"
  >
    <slot />
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      // 是否小一点
      small: {
        type: Boolean,
        default: false,
      },

      // 是否链接样式
      link: {
        type: Boolean,
        default: false,
      },

      // 是否灰色样式
      gray: {
        type: Boolean,
        default: false,
      },

      // 是否内联样式
      inline: {
        type: Boolean,
        default: false,
      },

      // 是否禁用
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      handleClick() {
        if (!this.disabled) {
          this.$emit('click')
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .button {
    height: 44px;
    background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
    border-radius: 1000px;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 34px;
    white-space: nowrap;
    user-select: none;

    &:active {
      background: linear-gradient(
        131deg,
        mix(#ff7e43, white, 80%) 0%,
        mix(#ff111c, white, 80%) 100%
      );
    }

    &.small {
      height: 38px;
    }

    &.link {
      background: transparent;
      color: #aaaaaa;

      &:active {
        background: transparent;
        opacity: 0.8;
      }
    }

    &.gray {
      background: #f5f5f5;
      color: #999999;

      &:active {
        background: mix(#f5f5f5, white, 80%);
        color: mix(#999999, white, 80%);
      }
    }

    &.inline {
      display: inline-flex;
    }

    &.disabled {
      pointer-events: none;
      opacity: 0.6;
    }
  }
</style>
